import { render, staticRenderFns } from "./NewsBtns.vue?vue&type=template&id=91db3696&"
import script from "./NewsBtns.vue?vue&type=script&lang=js&"
export * from "./NewsBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports